export default "__VITE_ASSET__6Rua0suo__"